<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <h4 class="page-title content__title">Historial cajas</h4>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light btn-sm" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
            </div>            
          </div>
        </div>
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Código</th>
                  <th>Caja</th>
                  <th>Fecha Apertura</th>
                  <th class="text-center">Monto Apertura</th>
                  <th>Fecha Cierre</th>
                  <th class="text-center">Monto Cierre</th>
                  <th>Usuario</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <td colspan="2"><span>No se encontraron registros</span></td>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>
                      {{item.nro_voucher}}
                      <ng-container *ngIf="!item.status_closed">
                        <span class="badge badge-info f-s-9">Abierta</span>
                      </ng-container>
                    </td>
                    <td>{{item.branchbox}}</td>
                    <td>{{item.date_opening}}</td>
                    <td class="text-center">{{item.amount_opening}}</td>
                    <td>{{item.date_closing}}</td>
                    <td class="text-center">{{item.amount_closing}}</td>
                    <td>{{item.username}}</td>
                    <td>
                      <a href="/{{branchofficeSlug}}/api/report/money/arqueo/{{item.id}}/a4" target="_blank">
                        <i class="far fa-file-pdf f-s-16 text-danger"></i>
                      </a>
                    </td>
                    <td>
                      <a (click)="detail(item.id)" class="pointer">
                        <i class="fas fa-clipboard-list f-s-16 text-primary m-r-3"></i>
                        <i class="fas fa-long-arrow-alt-right"></i>
                      </a>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
